import { UploadErrorType } from './UploadErrorMessage'
import { formatSize } from './uploadHelpers'

export const isValidSubtitleFile = (file: File): boolean => {
  const fileName = file.name.toLowerCase()
  return fileName.endsWith('.vtt') || fileName.endsWith('.srt') || fileName.endsWith('.scc')
}

export const isValidFileType = (file: File, acceptedFileType: 'image' | 'video' | 'text'): boolean => {
  if (acceptedFileType === 'image') return file.type.startsWith('image')
  if (acceptedFileType === 'video') return file.type.startsWith('video')
  if (acceptedFileType === 'text') return isValidSubtitleFile(file)
  return true
}

export const getValidationError = (
  file: File | null,
  acceptedFileType: 'image' | 'video' | 'text',
  maxSize: number | undefined,
  t: (key: string, fallback: string, options?: Record<string, unknown>) => string,
): UploadErrorType | null => {
  if (!file) return null

  if (acceptedFileType === 'image' && !file.type.startsWith('image')) {
    return {
      type: t('invalidFileFormat', 'Invalid file format'),
      message: t('supportedFormatsImageOnly', 'Supported File Formats: Any image file type (Image Files Only)', {
        maxSize: formatSize(maxSize),
      }),
    }
  }

  if (acceptedFileType === 'video' && !file.type.startsWith('video')) {
    return {
      type: t('invalidFileFormat', 'Invalid file format'),
      message: t('supportedFormatsVideoOnly', 'Supported File Formats: Any video file type (Video Files Only)'),
    }
  }

  if (acceptedFileType === 'text' && !isValidSubtitleFile(file)) {
    return {
      type: t('invalidFileFormat', 'Invalid file format'),
      message: t('supportedFormatsSubtitlesOnly', 'Supported File Formats: VTT, SRT, and SCC subtitle files only'),
    }
  }

  if (maxSize && file.size > maxSize) {
    return {
      type: t('fileTooLarge', 'File too large'),
      message: t('fileMustBeLessThan', 'File must be less than {{ maxSize }}', {
        maxSize: formatSize(maxSize),
      }),
    }
  }

  return null
}

export const getAcceptAttribute = (acceptedFileType: 'image' | 'video' | 'text'): string | undefined => {
  if (acceptedFileType === 'image') return 'image/*'
  if (acceptedFileType === 'video') return 'video/*'
  if (acceptedFileType === 'text') return '.vtt,.srt,.scc'
  return undefined
}
